React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('reactions')

module.exports = class ReactionIcon extends React.Component
  displayName: 'ReactionIcon'
  render: t.renderable ->
    { disabled, icon, withBorder, active, onClick } = @props

    t.span
      class: t.classify
        'reactions-add': true, 'is-disabled': disabled, 'mod-with-border': withBorder, 'is-active': active
      onClick: onClick
    , ->
      t.icon 'add-reaction',
        class: t.classify( 'reactions-add-icon': true )
        title: t.l 'add-reaction'
